

const app = {
    state: {
        // lang: '中文',
        // isFullScreen: false,
      
    },
    mutations: {
        
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/vuex/modules/app.ts